export const ACTIVATE_USER_BY_TOKEN_START = 'ACTIVATE_USER_BY_TOKEN_START';
export const ACTIVATE_USER_BY_TOKEN_SUCCESS = 'ACTIVATE_USER_BY_TOKEN_SUCCESS';
export const ACTIVATE_USER_BY_TOKEN_FAILURE = 'ACTIVATE_USER_BY_TOKEN_FAILURE';